module.exports = __webpack_public_path__ + "static/media/ohio-2.11ad3d99.jpg";